import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCard } from '@angular/material/card';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgIf } from '@angular/common';
import { handlerSnackbarApiError } from '../../../utils/snackbar.handler';
import { ApiCmdService } from '../../../services/api-cmd.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
  selector: 'app-create-touchpoint-privacy-configuration',
  standalone: true,
  imports: [FormsModule, MatButton, MatCard, MatFormField, MatIcon, MatIconButton, MatInput, MatLabel, MatProgressSpinner, NgIf, ReactiveFormsModule, MatCheckbox],
  templateUrl: './create-touchpoint-privacy-configuration.component.html',
  styleUrl: './create-touchpoint-privacy-configuration.component.scss',
})
export class CreateTouchpointPrivacyConfigurationComponent {
  creationForm: FormGroup;
  public isSubmitting = false;

  constructor(
    private fb: FormBuilder,
    private apiCmdService: ApiCmdService,
    private router: Router,
    private snackbar: MatSnackBar
  ) {
    this.creationForm = this.fb.group({
      touchpointCode: ['', Validators.required],
      exhibitionCode: [''],
      exhibitionGroupCode: [''],
      tgTouchpointConfigCode: ['', Validators.required],
      description: [''],
      skipValidation: [false],
    });
  }

  private setterIsSubmitting(value: boolean): () => void {
    return () => {
      this.isSubmitting = value;
    };
  }

  submitForm() {
    if (this.creationForm.valid) {
      this.isSubmitting = true;
      this.apiCmdService
        .createTouchpointPrivacyConfig({
          data: {
            touchpointCode: this.creationForm.value['touchpointCode'] || undefined,
            exhibitionCode: this.creationForm.value['exhibitionCode'] || undefined,
            exhibitionGroupCode: this.creationForm.value['exhibitionGroupCode'] || undefined,
            tgTouchpointConfigCode: this.creationForm.value['tgTouchpointConfigCode'] || undefined,
            description: this.creationForm.value['description'] || undefined,
            validate: !this.creationForm.value['skipValidation'],
          },
        })
        .subscribe({
          next: response => {
            this.isSubmitting = false;
            const id = response.data;
            this.router.navigate(['/configurazioni-tp/edit', id]);
          },
          error: err => handlerSnackbarApiError(this.snackbar, err, [this.setterIsSubmitting(false)]),
        });
    } else {
    }
  }

  navigateBack() {
    this.router.navigate(['/configurazioni-tp']);
  }
}
